import React, { useContext, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import CustomTooltip from "../../Elements/Tooltip"
import LightBoxSection from "../../Pages/Kdf/EditKdf/elementModal/elementSections/lightBoxSection/LightBoxSection"
import ElementModal from "../../Pages/Kdf/EditKdf/elementModal/ElementModal"
import { EditorInfoContext } from "../../../utils/userInfoContext"

const LightBoxModal = ({ openLightboxModal, docFileId, docId, setOpenLightBox }) => {
    const { setToolType, editLightBox } = useContext(EditorInfoContext)
    const [view, setView] = useState("list")

    const handleClose = () => {
        setOpenLightBox(false);
        setToolType("")
        setView("list")
    }
    return (
        <ElementModal
            openModal={openLightboxModal}
            heading={
                view === "list" ? "Lightbox options" : (
                    <span className="lb-crumb">
                        <CustomTooltip title={<p className="p-1 text-light mb-0">Back to all lightboxes</p>} placement="bottom">
                            <button type="button" className="lb-back-icon" aria-label="Back to all lightboxes" onClick={() => setView("list")}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                        </CustomTooltip>
                        <span className="lb-crumb-name">{editLightBox?.id ? editLightBox?.name : "New lightbox"}</span>
                    </span>
                )
            }
            handleCloseModal={() => handleClose()}
            z_index={'1001'}
            scrollable={true}
        >
            <LightBoxSection
                docFileId={docFileId}
                docId={docId}
                handleClose={handleClose}
                view={view}
                setView={setView}
            />
        </ElementModal>
    )
}
export default LightBoxModal
